"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrappedComponent = exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _generalStore = require("general-store");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _immutable = require("immutable");

var _TimelineConstants = require("crm_universal/timeline/TimelineConstants");

var _TimelineActions = _interopRequireDefault(require("crm_ui/timeline/data/actions/TimelineActions"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _UITab = _interopRequireDefault(require("UIComponents/nav/UITab"));

var _loggers = require("customer-data-tracking/loggers");

var _TimelineSimpleDateRangeDependency = _interopRequireWildcard(require("crm_ui/timeline/data/dependencies/TimelineSimpleDateRangeDependency"));

var _SubjectContext = require("crm_ui/profile/SubjectContext");

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _TimelineConstants2 = require("crm_ui/BET/timeline/TimelineConstants");

var _TimelineTabs = require("crm_ui/BET/timeline/TimelineTabs");

var TIMELINE_FILTER_ENGAGEMENT_TYPES = {
  ENGAGEMENTS_ACTIVITY: 'ENGAGEMENTS_ACTIVITY',
  ENGAGEMENTS_NOTES: 'ENGAGEMENTS_NOTES',
  ENGAGEMENTS_EMAILS_TRIMMED: 'ENGAGEMENTS_EMAILS_TRIMMED',
  ENGAGEMENTS_CALLS: 'ENGAGEMENTS_CALLS',
  ENGAGEMENTS_TASKS: 'ENGAGEMENTS_TASKS'
};
var propTypes = {
  children: _propTypes.default.node,
  dateRange: _propTypes.default.instanceOf(_TimelineSimpleDateRangeDependency.TimelineDateRange),
  defaultSelected: _propTypes.default.string.isRequired,
  onTabClick: _propTypes.default.func.isRequired,
  selected: _propTypes.default.string.isRequired,
  subject: _SubjectType.default
};

var logUsage = function logUsage(type, objectType) {
  if (type !== _TimelineConstants2.BET_CUSTOMER_SUMMARY_TAB && type !== _TimelineConstants2.BET_RENEWAL_SUMMARY_TAB) {
    _loggers.CrmLogger.logRecordInteraction(objectType, {
      action: 'use timeline tabs',
      type: _TimelineConstants.ENGAGEMENT_TYPE_TO_I18N_KEY[type]
    });
  }
};

var ProfileTimelineTabs =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ProfileTimelineTabs, _Component);

  function ProfileTimelineTabs(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ProfileTimelineTabs);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ProfileTimelineTabs).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.renderTab = _this.renderTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.partial = (0, _ComponentMethods.makePartial)();
    _this.state = {
      BETDidCloseYourDealModalShow: false
    };
    return _this;
  }

  (0, _createClass2.default)(ProfileTimelineTabs, [{
    key: "handleBETCloseYourDealModalShown",
    value: function handleBETCloseYourDealModalShown() {
      this.setState({
        BETDidCloseYourDealModalShow: true
      });
    }
  }, {
    key: "handleTabClick",
    value: function handleTabClick(type) {
      var dateRange = this.props.dateRange;
      var _this$context = this.context,
          objectType = _this$context.objectType,
          subjectId = _this$context.subjectId;

      if (type === this.props.selected) {
        return null;
      }

      logUsage(type, objectType);
      this.props.onTabClick(type);

      if (type === TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_ACTIVITY) {
        return _TimelineActions.default.clearFavoriteEventOverride(objectType);
      }

      var requestPayload = (0, _immutable.Map)({
        eventOptions: (0, _immutable.List)([type]),
        fromDate: dateRange.get('fromDate'),
        now: dateRange.get('now'),
        objectType: objectType,
        subjectId: subjectId
      });
      return _TimelineActions.default.overrideFavoriteEvent(objectType, (0, _immutable.List)([type]), requestPayload);
    }
  }, {
    key: "handleRenderTab",
    value: function handleRenderTab(type) {
      var i18nkey = _TimelineConstants.ENGAGEMENT_TYPE_TO_I18N_KEY[type];
      return this.renderTab(i18nkey, type, this.props.children);
    }
  }, {
    key: "renderTab",
    value: function renderTab(i18nkey, type, body) {
      return _react.default.createElement(_UITab.default, {
        title: _react.default.createElement(_FormattedHTMLMessage.default, {
          message: "profileContentTimeline.tabTitles." + i18nkey
        }),
        tabId: type,
        key: type,
        onClick: this.partial(this.handleTabClick, type),
        "data-selenium-test": "timeline-tab-filter-" + i18nkey
      }, body);
    }
  }, {
    key: "render",
    value: function render() {
      var subject = this.props.subject;
      var objectType = this.context.objectType;
      var tabRenderer = this.renderTab;
      var BETDidCloseYourDealModalShow = this.state.BETDidCloseYourDealModalShow;
      var handleBETCloseYourDealModalShown = this.handleBETCloseYourDealModalShown;
      return _react.default.createElement(_UITabs.default, {
        className: "p-top-3 p-x-4",
        panelClassName: "p-x-0",
        defaultSelected: this.props.defaultSelected,
        selected: this.props.selected
      }, (0, _TimelineTabs.BETRenewalSummaryTab)({
        tabRenderer: tabRenderer,
        subject: subject,
        objectType: objectType
      }), (0, _TimelineTabs.BETCustomerSummaryTab)({
        tabRenderer: tabRenderer,
        subject: subject,
        objectType: objectType,
        BETDidCloseYourDealModalShow: BETDidCloseYourDealModalShow,
        handleBETCloseYourDealModalShown: handleBETCloseYourDealModalShown
      }), Object.keys(TIMELINE_FILTER_ENGAGEMENT_TYPES).map(this.handleRenderTab));
    }
  }]);
  return ProfileTimelineTabs;
}(_react.Component);

exports.WrappedComponent = ProfileTimelineTabs;
ProfileTimelineTabs.contextType = _SubjectContext.SubjectContext;
ProfileTimelineTabs.propTypes = propTypes;

var _default = (0, _generalStore.connect)({
  dateRange: _TimelineSimpleDateRangeDependency.default
})(ProfileTimelineTabs);

exports.default = _default;